import { Component, OnInit ,EventEmitter ,Input ,Output } from '@angular/core';
import { Router } from '@angular/router';
import { mainRestaurantItem} from 'src/app/models/category';
import { MyOrder } from 'src/app/models/order';
import { AppProxy } from 'src/app/services/app-proxy';
import { BussinssService } from 'src/app/services/bussinss-service';
import { OrdersService } from 'src/app/services/order-service';
import { PopupOrderComponent } from '../popup-order/popup-order.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-resraurant-item',
  templateUrl: './resraurant-item.component.html',
  styleUrls: ['./resraurant-item.component.scss']
})
export class ResraurantItemComponent implements OnInit {
  stars:number[]=[1,2,3,4,5];
  @Input() mainRestaurantItem:mainRestaurantItem;
  @Input() indexList:number;
  @Input() restaurantCategory:number;
  @Output()
  change: EventEmitter<number> = new EventEmitter<number>();
  categoryType:number=1;
  fevorit='assets/images/Restorant_Page_Fevorit_Button.png';
  fevoritActive='assets/images/Fevorit_Activ.png';
  order:MyOrder;
  localId;
  isClick=false;
  Rate= new Array<number>(3);
   minimumOrderText = "";
  timeDeliveryText = '25-35 דקות';
  deliveryPriceText = '₪20 דמי משלוח';
  dayTime="";

  constructor(private router: Router, private proxy: AppProxy,private matDialog: MatDialog,
    private bussinssService: BussinssService ,private orderService:OrdersService) {  }

  onClickCategory(CategoryNumber:number)
  {
    this.isClick=true;
    if(localStorage.SMS=="")
   this.proxy.showError("חובה להכניס קוד","");
    if(localStorage.ACCESS_TOKEN  == "null" || localStorage.SMS_CODE=="")
    this.proxy.showError("אינך מחובר נא להתחבר","");
    else
    {
      localStorage.PRICE=0;
    this.orderService.restaurant=null;
    let id=this.mainRestaurantItem.ID == 0 ? this.mainRestaurantItem.RstaurantID : this.mainRestaurantItem.ID;
    if(CategoryNumber==1 || this.restaurantCategory==8)
    {
      //localStorage.ID=id;
     
      //  if ((this.mainRestaurantItem.IsOpen != undefined && this.mainRestaurantItem.IsOpen == 0) || this.mainRestaurantItem.IsTemporaryClosed == 1)
      //   this.proxy.showError("המסעדה סגורה\n אין אפשרות לבצע הזמנה","");
      //  //this.openDialog(); 
      //   else{
       this.orderService.getOrderDetails(false).subscribe((res:any)=>{
         this.order=res;
         if(this.order.OrderID==0 && (this.order.list==null || this.order.list.length==0)) 
         {
          localStorage.MENU_ID=0;
           this.orderService.order=null;
          sessionStorage.CATEGORY_FILTER="";
          localStorage.ID=id;
        // this.dataService.endToppings.next(true);
          this.change.emit();
          let url: string = "/restaurant" + (this.mainRestaurantItem.NameEn != '' ? '/' +this.mainRestaurantItem.NameEn :"");
          this.router.navigateByUrl(url);
         }
       else
    {
      if(!this.order || this.order.list==null || this.order.list.length==0 )
              {
              this.orderService.setUpdateOrder
              ({
                OrderID: this.order ?this.order.OrderID : 0,
                IsDelivery:0,
                IsPickUp:0,
                IsSitting:0,
                PaymentType:1,
                MenuID:null,
                Count:null,
                Status:0,
                Note:null,
                IsAddress : 1,
                Address : null,
                Latitude : null,
                Longitude : null,
                IsGiftCard : null,
                GiftNumber:null,
                SumGift:null,
                card_mask : null,
                card_validity:null,
              
              })
              // (this.order.OrderID,0,0,0,1,
              // null,null,0,null,1,null,null,null,null,null,null,null,null,0)
              .subscribe((res:any)=>{
                this.orderService.order=null;
                sessionStorage.CATEGORY_FILTER="";
                localStorage.ID=id;
                // this.dataService.endToppings.next(true);
                this.change.emit();
                let url: string = "/restaurant/" + this.mainRestaurantItem.NameEn
                this.router.navigateByUrl(url);
             // this.router.navigate(['../restaurant']);
                 });
              }
              else
            {
              localStorage.ID=this.mainRestaurantItem.ID != 0 ? this.mainRestaurantItem.ID : this.mainRestaurantItem.RstaurantID;
      this.matDialog.open(PopupOrderComponent, {
        data: { OrderID: this.order.OrderID },
      });
    }
  }
  });
      
    }
    else if(CategoryNumber==2)
    {
     // localStorage.ID=id;
     localStorage.ID_CATEGORY=id;
      let url: string = "/restaurantCategory/" + id
      this.router.navigateByUrl(url);
      //this.router.navigate(['../restaurantCategory']);
    }
  // }

}}

  ngOnInit(): void {
    this.localId=localStorage.ID;
  
      if(this.mainRestaurantItem.Rate==0 ||this.mainRestaurantItem.Rate==null)
    this.mainRestaurantItem.Rate=3;
     this.minimumOrderText = this.mainRestaurantItem.MinimumOrder ?  `מיני׳ ${this.mainRestaurantItem.MinimumOrder} ₪` : ""
   this.timeDeliveryText = this.mainRestaurantItem.DeliveryTime ? `${this.mainRestaurantItem.DeliveryTime} דקות`  :"";
   this.deliveryPriceText = this.mainRestaurantItem.DeliveryPrice ? `₪${this.mainRestaurantItem.DeliveryPrice} דמי משלוח` : "";
  }


}

